import React from 'react';
import { motion } from 'framer-motion';
import { CONFIG } from '../config/variables';

const HowItWorks = () => {
  const steps = [
    { number: '1', title: 'Submit Enquiry', description: 'Tell us about your business and goals' },
    { number: '2', title: 'Receive Plan', description: 'Get a custom landing page plan' },
    { number: '3', title: 'Build', description: 'We create your custom landing page' },
    { number: '4', title: 'Review', description: 'Review and request any changes' },
    { number: '5', title: 'Launch', description: 'Go live and start generating enquiries' }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-gradient-to-br from-blue-900/20 to-purple-900/20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
            How it works
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            A simple process to get your premium landing page live and generating enquiries.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-6">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="text-center"
            >
              <div className="bg-gradient-to-r from-blue-500 to-purple-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white font-bold text-xl">{step.number}</span>
              </div>
              <h3 className="text-white font-semibold mb-2">{step.title}</h3>
              <p className="text-white/70 text-sm">{step.description}</p>
              {/* Connection line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-full w-full h-0.5 bg-gradient-to-r from-blue-500 to-purple-600 transform -translate-y-1/2"></div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-6 max-w-2xl mx-auto">
            <p className="text-blue-300 font-medium">
              We only build a limited number of pages per week to maintain quality.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;